import { useEffect } from 'react';
import { EMAIL_ADD, LOCATION_ADD, OFFICE_HOURS, PHONE } from './constants';

export const SITE_URL = 'https://quilatonlawoffice.com';
export const DEFAULT_IMAGE = `${SITE_URL}/qlo-logo.png`;

export const lawOfficeSchema = {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    name: 'Quilaton Law Office',
    url: SITE_URL,
    logo: DEFAULT_IMAGE,
    image: DEFAULT_IMAGE,
    telephone: PHONE,
    email: EMAIL_ADD,
    address: {
        '@type': 'PostalAddress',
        streetAddress: LOCATION_ADD,
        addressLocality: 'Cebu City',
        addressRegion: 'Cebu',
        postalCode: '6000',
        addressCountry: 'PH',
    },
    openingHours: OFFICE_HOURS,
    sameAs: [
        'https://facebook.com/quilatonlawoffice',
        'https://linkedin.com/in/atty-abelardo-quilaton-jr-5a3b25248/',
    ],
};

export default function SEO({
    title,
    description,
    path = '/',
    canonical,
    image = DEFAULT_IMAGE,
    schema,
    type = 'website',
    robots = 'index,follow',
}) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const canonicalUrl = canonical || `${SITE_URL}${normalizedPath}`;

    useEffect(() => {
        document.title = title;

        const meta = [
            ['name', 'description', description],
            ['name', 'robots', robots],
            ['property', 'og:title', title],
            ['property', 'og:description', description],
            ['property', 'og:type', type],
            ['property', 'og:url', canonicalUrl],
            ['property', 'og:image', image],
            ['name', 'twitter:card', 'summary_large_image'],
            ['name', 'twitter:title', title],
            ['name', 'twitter:description', description],
            ['name', 'twitter:image', image],
        ];

        meta.forEach(([attribute, key, content]) => {
            let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, key);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        });

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', canonicalUrl);

        const schemaId = 'page-structured-data';
        const existingSchema = document.getElementById(schemaId);
        if (existingSchema) existingSchema.remove();

        if (schema) {
            const script = document.createElement('script');
            script.id = schemaId;
            script.type = 'application/ld+json';
            script.text = JSON.stringify(schema);
            document.head.appendChild(script);
        }
    }, [title, description, canonicalUrl, image, robots, schema, type]);

    return null;
}
